import axios from "axios";
import ApiNames from "../constants/ApiNames";
import { Config } from "../constants/Config";
import { apiClient } from "./NetworkService";
import type {
  ArtworkResponse,
  CheckJCUserResponse,
  HeaderEnrichmentResponse,
  JcPlanResponse,
} from "../types/CheckJcUsertype";

const getHeaders = (token?: string) => {
  return token ? { headers: { Authorization: `Bearer ${token}` } } : {};
};
export const headerEnrichmentService =
  async (): Promise<HeaderEnrichmentResponse> => {
    const res = await apiClient.get(
      ApiNames.headerEnrichment,
      getHeaders(token),
    );
    return res.data;
  };

export const checkJCUserService = async (
  msisdn: string,
): Promise<CheckJCUserResponse> => {
  const res = await apiClient.get(`${ApiNames.checkjcUser}/${msisdn}`);
  return res.data;
};

export const getJcPlanService = async (
  planId: string,
): Promise<JcPlanResponse> => {
  const res = await apiClient.get(`${ApiNames.jcGetPlan}?planId=${planId}`);
  return res.data;
};

export const getArtworkService = async (
  identifier: string,
  param_name: string,
): Promise<ArtworkResponse> => {
  const res = await axios.get<ArtworkResponse>(
    `${Config.artworkBaseUrl}artwork`,
    {
      params: { identifier, param_name },
    },
  );
  return res.data;
};
